import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiServiceAssessment {
    constructor(private http: HttpClient) { }

    getData(): Observable<any> {
        return this.http.get<any>('https://webapp.sci.buu.ac.th/assessment-dev/api/admin/getallchoice');
    }

    postData(data: any): Observable<any> {
        return data;
        return this.http.post<any>('https://api.example.com/data', data);
    }
}

// let datachoice = [];
// const myFunction = async () => {
//     const response = await fetch("https://webapp.sci.buu.ac.th/assessment-dev/api/admin/getallchoice");    
//     const data = await response.json();        
//     datachoice.push(data.data);
// };
// myFunction()

// const addForm = async () =>{
//     alert(1)
// }
// export {datachoice,addForm};
